import React from 'react'
import { useParams } from 'react-router-dom'
import { connections } from '../../../../../api/integrations'
import Loading from '../../../../molecules/Loading'
import ErrorDisplay from '../../../../molecules/ErrorDisplay'
import NotFoundItem from '../../../NotFoundItem'
import ConnectionRequest from '../shared/ConnectionRequest'

function AdminRequestItem () {
  const { requestId } = useParams()
  const { data, isLoading, error } = connections.useGetIntegrationConnectionRequestById(requestId)

  if (isLoading) {
    return (
      <Loading />
    )
  }

  if (error) {
    return (
      <ErrorDisplay error={error} />
    )
  }

  if (!data?.connectionRequest) {
    return (
      <NotFoundItem itemName='Request' parentPath='/admin/requests' />
    )
  }

  return (
    <ConnectionRequest request={data.connectionRequest} />
  )
}

export default AdminRequestItem
